/* eslint-disable max-len */
import React, { useState ,useContext} from 'react'
import AnimatedList from '../../../components/Animation/AnimatedList'
import AnimatedButton from '../../../components/Animation/AnimatedButton'
import { useNavigate } from 'react-router-dom'
import { useSelector ,useDispatch} from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { toggleRowSelection } from '../../../redux/MultiselectRows'
import moment from 'moment'
import formatMobileNumber from '../../../CommonMethods/FormatMobileNumber'
import { convertEpochToDateFormat } from '../../../CommonMethods/DateConversion'
import ConfirmationPrompt from '../../../components/ConfirmationPrompt'
import AnimatedModel from '../../../components/Animation/AnimatedModel'
import GlobalContext from '../../../components/Context/GloablContext'
import { useAssocitateTemplateToPatientMutation } from '../../../features/patientSlice'
import { handleEditMessageSent } from '../../../redux/systemConfigSlice'
const TableTemplateBody=({tableData,
    List,
    edit,
    indexNum,
    pageNumber,
    selectedIndex,
    setSelectedIndex,
    selectedRef,
    lastIndex,
    loading,
    handleDelete,
    isPatientTemplateTable,
    setChooseTemplate,
    templateTrigger,
    selectedRowIndex,
    setTemplateId,
    setSelectedRowIndex,
    templateResult,
    queryParams,
    setPageNumber,
    patient_id,
    setConfirmationState})=>{
    const [AssocitateTemplateToPatient] = useAssocitateTemplateToPatientMutation()
    const navigate=useNavigate()
    const auth=useSelector(state=>state?.auth)
    const {userType}=auth 
    const { setToastmessage,setToastErrorMessage ,sendMessageToStartEditing,receiveMessageFromSocket,editSocket} = useContext(GlobalContext);
    const dispatch=useDispatch()
    const [isSelectTemplateModalOpen,setIsSelectTemplateModalOpen] = useState(false)
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const [searchParams,setSearchParams]=useSearchParams({})
    const [hoverId,setHoverId] = useState('')
    const selectedRows=useSelector(state=>state?.MultiSelectSlice?.selectedRows?.selectedIds)
    const [isDeleteOpen, setIsDeleteOpen] = useState(false);
    const [isYesCLicked,setIsYesClicked] = useState(false)
    const messageSent = useSelector(state=>state?.systemConfigData?.messageSent)
    const handelActionButton = async(indexNum) =>{
        setSelectedIndex(indexNum)
    }

    const handleDeleteItem = () => {
        handleDelete(tableData._id.$oid)
    }

    const handleTemplateSelection=()=>{
        setIsYesClicked(true)
        templateTrigger(tableData?._id?.$oid)
        if(edit){
            let body={
                "patient_id":patient_id,
                "template_id":tableData?._id?.$oid
            }
            const res=AssocitateTemplateToPatient(body)
            if(res?.data?.message==="Monitoring template associated successfully"){
    
            }else{
                
            }
    
        }
        
        setPageNumber(queryParams)
        setTemplateId(tableData?._id?.$oid)
      
    
    }

    const handleSelectTemplate=()=>{
        setHoverId(true)
        setIsSelectTemplateModalOpen(true)
    }

  
    const date=convertEpochToDateFormat(tableData?.created_at,dateformat)
  
    return(
        <>
            <AnimatedList
                id={tableData._id.$oid}
                rowStatus={tableData.status}
                keyItem={indexNum}
                hoverId={hoverId}
                selectedIndex={selectedRowIndex}
                isPatientTemplateTable={isPatientTemplateTable}
                isSelectTemplateModalOpen={isSelectTemplateModalOpen}
                cursorpointer
                handleClick={(e)=>{
                    if (e.target.classList.contains('prevent-click')) {
                        return;
                    } else {
                        isPatientTemplateTable===undefined?navigate(`/manage-monitoring-condition-templates/${tableData._id.$oid}`,{state:Array.isArray(location.state)?'':Object.fromEntries(searchParams)}):handleSelectTemplate()
                    }
                }}
                child={
                    <>
                        <td className={`px-[18px] py-2 text-sm text-start ${isPatientTemplateTable!==undefined&&tableData?._id?.$oid===selectedRowIndex?'text-[#972E4C] font-[600]':'text-[#031624] font-normal'} `}>{tableData?.template_name}</td>
                        <td className={`px-[18px] py-2 text-sm text-start ${isPatientTemplateTable!==undefined&&tableData?._id?.$oid===selectedRowIndex?'text-[#972E4C] font-[600]':'text-[#031624] font-normal'}`}>
                            {convertEpochToDateFormat(tableData?.created_at,dateformat)}
                        </td>
                        <td className={`px-[18px] py-2 text-sm text-start ${isPatientTemplateTable!==undefined&&tableData?._id?.$oid===selectedRowIndex?'text-[#972E4C] font-[600]':'text-[#031624] font-normal'}`}>
                            {tableData?.created_by===""||tableData?.created_by===undefined?"-":tableData?.created_by}
                        </td>
                        <td className={`px-[18px] py-2 text-sm text-start ${isPatientTemplateTable!==undefined&&tableData?._id?.$oid===selectedRowIndex?'text-[#972E4C] font-[600]':'text-[#031624] font-normal'}`}>
                            {convertEpochToDateFormat(tableData?.updated_at,dateformat)}
                        </td>
                       
                        {isPatientTemplateTable===undefined&&<td className={`px-3 py-2 text-sm text-start font-normal text-[#031624] rounded-tr-[2px] sticky right-0 prevent-click bg-white last-td`}>
                            <div  className="relative flex items-center justify-center" data-te-dropdown-ref>
                                <button type='button' className="text-white transition duration-150 ease-in-out w-[40px] h-[34px] rounded-[50%] flex justify-center items-center prevent-click"
                                    id={"id"}
                                    // disabled={(userCognitoEmail === tableData.email_address) ? true : false}
                                    onClick={() =>handelActionButton(indexNum) }
                                    data-te-dropdown-toggle-ref
                                    data-testid="list-users"
                                    aria-expanded="false"
                                    data-te-ripple-init
                                    // disabled={() => handelActionButton()}
                                    data-te-ripple-color="light">
                                    <img loading="lazy" decoding="async" src="/images/3_dots_list.svg" alt="icon" className="prevent-click" />
                                </button>
                                {selectedIndex===indexNum&& <ul  ref={selectedRef}  className={`border border-[#C2DCEF] p-2.5 absolute z-[0] float-left m-0 ${lastIndex === indexNum+1 ? ' top-[0px]' : ' top-0'} right-[80px] min-w-[135px] list-none rounded-lg  bg-white bg-clip-padding text-left [&[data-te-dropdown-show]]:block prevent-click`} aria-labelledby="dropdownMenuButton2" data-te-dropdown-menu-ref >
                                    
                                           
                                    <li>
                                        <AnimatedButton
                                            handleClick={(e) => {}}
                                            buttonName={"View"}
                                            locnState={Object.fromEntries(searchParams)}
                                            link={`/manage-monitoring-condition-templates/${tableData._id.$oid}`}
                                            className="block w-full text-start whitespace-nowrap bg-transparent hover:text-[#008586] hover:bg-[#F4F7FC] px-[2px] rounded py-1 mb-2.5 text-base font-normal text-[#000000] prevent-click" />
                                    </li>
                                    <li>
                                        <AnimatedButton
                                            handleClick={() => {
                                                if(!messageSent){
                                               
                                                    sendMessageToStartEditing(tableData?.template_name)
                                                    let message
                                                    editSocket.onmessage = (event) =>{
                                                        message = event.data

                                                        if(JSON.parse(message)?.success_status===true && JSON.parse(message)?.message==='Success'){
                                                      
                                                            navigate(`/manage-monitoring-condition-templates/add-template/${tableData._id.$oid}`,{state:Object.fromEntries(searchParams)})
                                                        } else{
                                                            dispatch(handleEditMessageSent(false))
                                                        
                                                            { (JSON.parse(message)?.adminId) &&
                                                            setToastErrorMessage(`A user with username ${decodeURIComponent( JSON.parse(message)?.adminId)} is already editing this monitoring condition template`)
                                                            }
                                                        }
                                                    }    
                                                }
                                            
                                            }}
                                            datatestid="edit-button"
                                            buttonName={"Edit"}
                                            locnState={Object.fromEntries(searchParams)}
                                            // link={`/manage-monitoring-condition-templates/add-template/${tableData._id.$oid}`}
                                            className="block w-full text-start whitespace-nowrap bg-transparent hover:text-[#008586] hover:bg-[#F4F7FC] px-[2px] rounded py-1 mb-2.5 text-base font-normal text-[#000000] prevent-click" />
                                    </li>
                                    <li>
                                        <AnimatedButton
                                            handleClick={() => { setIsDeleteOpen(true) }}
                                            buttonName={`Delete`}
                                            className="block w-full text-start whitespace-nowrap bg-transparent  hover:text-[#008586] hover:bg-[#F4F7FC] px-[2px] rounded py-1 text-base font-normal text-[#000000] prevent-click" />
                                    </li>
                                    <div className='absolute top-[12px] right-[-9px] rotate-[45deg] w-4 h-4 border-t border-r border-[#C2DCEF] bg-[#fff] z-0'>

                                    </div> 
                                </ul>}
                                
                            </div>
                        </td>}
                    </>
                    
                }/>
            {isDeleteOpen &&
            <AnimatedModel
                Children={
                    <ConfirmationPrompt
                        handleOnCLickActivate={handleDeleteItem}
                        handleClose={() => setIsDeleteOpen(false)}
                        tittle= {'Delete'}
                        message = {`Are you sure you want to delete this monitoring conditions template?`}
                        buttonName = {"Yes"}
                        loadingActivation={loading}
                        CancelButton = {"No"}
                    />
                }
            />
            }
            {isSelectTemplateModalOpen &&
            <AnimatedModel
                Children={
                    <ConfirmationPrompt
                        handleOnCLickActivate={handleTemplateSelection}
                        handleClose={() => {setIsSelectTemplateModalOpen(false)}}
                        tittle= {'Choose Template'}
                        message = {`Are you sure you want to choose this template to associate to the patient?`}
                        buttonName = {"Yes"}
                        disabled={templateResult?.isFetching}
                        loadingActivation={isYesCLicked&&templateResult?.status!=='rejected'}
                        CancelButton = {"No"}
                    />
                }
            />
            }
        </>
    )
}

export default TableTemplateBody